import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { loginSelectors } from '../redux/modules/Login';
import windowMethods from '../util/windowMethods';

/** Orgs allowed for automatic SSO redirect during initial rollout. */
const AUTO_SSO_REDIRECT_ORGS = new Set(['fountainlife']);

/**
 * When an account only supports custom SSO, automatically redirect to Cognito
 * instead of showing the "Sign in with SSO" button.
 */
function useAutoSsoSignInRedirect(): boolean {
  const clientDisablesLifeomic = useSelector(
    loginSelectors.selectCustomClientDisablesLifeomic
  );
  const clientDisablesCustom = useSelector(
    loginSelectors.selectCustomClientDisablesCustom
  );
  const cognitoLoginUrl = useSelector(loginSelectors.selectCognitoLoginUrl);
  const subDomain = useSelector(loginSelectors.selectSubDomain);

  const isRolloutOrg =
    !!subDomain && AUTO_SSO_REDIRECT_ORGS.has(subDomain.toLowerCase());

  const shouldAutoRedirect =
    isRolloutOrg && clientDisablesLifeomic && !clientDisablesCustom;

  useEffect(() => {
    if (shouldAutoRedirect && cognitoLoginUrl) {
      windowMethods.setLocationHref(
        `${window.location.origin}${cognitoLoginUrl}`
      );
    }
  }, [shouldAutoRedirect, cognitoLoginUrl]);

  return shouldAutoRedirect;
}

export default useAutoSsoSignInRedirect;
